import { data } from 'react-router-dom';
import { get, post, put, del } from './api';

// Create a new SalesMan
export const createSalesMan = (data) => {
  return post('/salesmen', data);
};


export const getAllSalesMan = ( ) => {
  return get('/salesmen');
};


// Get all SalesMan with pagination
export const getAllSalesManList = (queryStrings) => {
  return get(`/salesmen${queryStrings}`);
};

// Get a SalesMan by ID
export const getSalesManById = (id) => {
  return get(`/salesmen/${id}`);
};

// Update a SalesMan
export const updateSalesMan = (id, data) => {
  return put(`/salesmen/${id}`, data);
};

// Delete a SalesMan (soft delete if your backend supports it)
export const deleteSalesMan = (id) => {
  return del(`/salesmen/${id}`);
};
